export default "__VITE_PUBLIC_ASSET__21d58296__"